import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
    textSlow: {
        color: 'white',
        marginRight: '25px'
    },
    textFast: {
        color: 'white',
        marginLeft: '25px'
    },
    formControl: {
        backgroundColor: 'white',
        borderRadius: '4px',
        marginRight: '10px'
    },
    tooltip: {
        fontSize: '20px'
    },
    visualizeButton: {
        backgroundColor: '#01dc01',
        color: 'white'
    }


}))